// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1qkqn","header":"styles_header__2oktD","content":"styles_content__7ngVw","links":"styles_links__1IM1Q"};